import { memo } from 'react';
import classNames from 'classnames';
import './index.scss';

type IItemType = 'single_level' | 'multi_level';

interface IApplicableData {
    itemType: IItemType;
    title: string;
    list: Array<{ id: number; name: string; list?: Array<{ id: number; name: string }> }>;
}

interface IProps {
    applicableData: IApplicableData[];
}

const ApplicableSubjects = ({ applicableData }: IProps) => {
    if (!applicableData?.length) return null;

    return (
        <div className="rights-applicable-info">
            <div className="rights-applicable-title">*适用于以下科目</div>
            {applicableData.map(item => (
                <div key={item.title} className="rights-applicable-container">
                    <div className="rights-applicable-container__title">{item.title}</div>
                    {item.itemType === 'single_level' ? (
                        <div className="rights-applicable-container__single-container">
                            {item.list.map(childItem => (
                                <div className="rights-applicable-container__single-item" key={childItem.id}>
                                    {childItem.name}
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="rights-applicable-container__multi-container">
                            {item.list.map((childItem, index) => (
                                <div
                                    key={childItem.id}
                                    className={classNames(
                                        'rights-applicable-container__multi-item',
                                        index % 2 && 'rights-applicable-container__multi-item--even'
                                    )}
                                >
                                    <span className="rights-applicable-container__subject-name">{childItem.name}</span>
                                    {!!childItem.list?.length && (
                                        <div className="rights-applicable-container__two-level-subject">
                                            {childItem.list.map(childItem2 => (
                                                <div className="rights-applicable-container__two-level-subject-name" key={childItem2.id}>
                                                    {childItem2.name}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default memo(ApplicableSubjects);
